import axios from "axios";

// Set up API base URL
axios.defaults.baseURL = "https://api.emboxvn.com";

// Configure axios to include auth token from localStorage
axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default axios;